export default class OubliLogin {
  constructor (oubliLoginInput) {
    this.lastName = oubliLoginInput ? oubliLoginInput.lastName : null
    this.firstName = oubliLoginInput ? oubliLoginInput.firstName : null
    this.lastThreeDigitsPan = oubliLoginInput ? oubliLoginInput.lastThreeDigitsPan : null
    this.siret = oubliLoginInput ? oubliLoginInput.siret : null
    this.entityName = oubliLoginInput ? oubliLoginInput.entityName : null
    this.entityId = oubliLoginInput ? oubliLoginInput.entityId : null
    this.isCardHolder = oubliLoginInput ? oubliLoginInput.isCardHolder : null
  }
}

export class OubliPassword {
  constructor (oubliPasswordInput) {
    this.lastName = oubliPasswordInput ? oubliPasswordInput.lastName : null
    this.firstName = oubliPasswordInput ? oubliPasswordInput.firstName : null
    this.login = oubliPasswordInput ? oubliPasswordInput.login : null
    this.zipCode = oubliPasswordInput ? oubliPasswordInput.zipCode : null
  }
}
